<template>
    <div class="row top" v-if="certificate_due">
        <div class="col-12 col-md-3">
            <div class="card card-dashboard">
                <div class="card-body border-success text-center"
                    :class="isDueWarning[0]"
                >
                    <span class="text-success font-weight-bold"
                        :class="isDueWarning[1]"
                    >
                        {{ certificate_due }}
                    </span>
                    <div class="card-title">Venci. del Certificado</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "DashboardCertificateDue",
        props: ['certificate_due'],

        computed: {
            isDueWarning() {
                if (this.certificate_due) {
                    const dueDate = moment(this.certificate_due)
                    const now = moment()
                    const diffInDays = dueDate.diff(now, 'days')

                    if (diffInDays <= 30) {
                        return ['border-danger', 'text-danger']
                    } else if (diffInDays <= 90) {
                        return ['border-warning', 'text-warning']
                    } else {
                        return ['', '']
                    }
                }
                return ['', '']
            }
        }
    }
</script>


// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/components/CertificateDue.vue